import { SITE_URL } from './route-data.mjs';

export const SITE_DESCRIPTION =
  'Meduler is a privacy-first medication management app for patients and caregivers, with reminders, dose tracking, caregiver support, and offline-first organization.';

export function generateSiteStructuredData() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#organization`,
        name: 'Meduler',
        url: SITE_URL,
        description: SITE_DESCRIPTION,
        logo: `${SITE_URL}/icon.svg`,
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: 'support@meduler.com',
          url: `${SITE_URL}/contact`,
        },
    address: {
          '@type': 'PostalAddress',
          addressCountry: 'US',
        },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${SITE_URL}/#software`,
        name: 'Meduler',
        url: SITE_URL,
        description: SITE_DESCRIPTION,
        applicationCategory: 'HealthApplication',
        operatingSystem: 'Web, iOS, Android',
        offers: [
          {
            '@type': 'Offer',
            name: 'Meduler Free',
            price: '0',
            priceCurrency: 'USD',
            description: 'Core medication management, reminders, dose logging, and offline support.',
            url: `${SITE_URL}/pricing`,
          },
          {
            '@type': 'Offer',
            name: 'Meduler Plus',
            price: '4.99',
            priceCurrency: 'USD',
            description: 'Advanced adherence insights, extended history, expanded sharing, custom reminder patterns, and priority support.',
            url: `${SITE_URL}/pricing`,
          },
        ],
      },
    ],
  };
}